/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const STAR_VIEWBOX = 15;

const STAR_PATH =
  'M7.0177 0.8631C7.04692 0.804074 7.09205 0.754388 7.14801 0.71965C7.20396 0.684912 7.26851 0.666504 7.33437 0.666504C7.40023 0.666504 7.46478 0.684912 7.52074 0.71965C7.57669 0.754388 7.62182 0.804074 7.65104 0.8631L9.19104 3.98243C9.29249 4.18774 9.44225 4.36537 9.62745 4.50007C9.81266 4.63477 10.0278 4.72251 10.2544 4.75577L13.6984 5.25977C13.7636 5.26922 13.8249 5.29675 13.8754 5.33923C13.9258 5.38172 13.9633 5.43747 13.9837 5.50017C14.0041 5.56288 14.0066 5.63004 13.9908 5.69406C13.975 5.75808 13.9416 5.8164 13.8944 5.86243L11.4037 8.28777C11.2394 8.44783 11.1166 8.64542 11.0456 8.86352C10.9746 9.08162 10.9577 9.31369 10.9964 9.53977L11.5844 12.9664C11.5959 13.0317 11.5888 13.0988 11.564 13.1602C11.5392 13.2216 11.4977 13.2748 11.4441 13.3138C11.3905 13.3527 11.327 13.3758 11.2609 13.3804C11.1949 13.385 11.1288 13.3709 11.0704 13.3398L7.9917 11.7211C7.78885 11.6146 7.56316 11.5589 7.33404 11.5589C7.10492 11.5589 6.87923 11.6146 6.67637 11.7211L3.59837 13.3398C3.53992 13.3707 3.47397 13.3846 3.408 13.3799C3.34204 13.3752 3.27872 13.3521 3.22523 13.3132C3.17175 13.2743 3.13026 13.2212 3.10547 13.1599C3.08069 13.0986 3.07361 13.0316 3.08504 12.9664L3.67237 9.54043C3.71117 9.31425 3.69436 9.08203 3.6234 8.8638C3.55243 8.64556 3.42944 8.44787 3.26504 8.28777L0.77437 5.8631C0.726766 5.81712 0.693033 5.7587 0.677012 5.69448C0.660991 5.63027 0.663328 5.56284 0.683756 5.49989C0.704184 5.43694 0.741882 5.38099 0.792555 5.33842C0.843228 5.29585 0.904839 5.26837 0.97037 5.2591L4.4137 4.75577C4.64054 4.72277 4.85596 4.63514 5.04143 4.50042C5.22689 4.36571 5.37684 4.18795 5.47837 3.98243L7.0177 0.8631Z';

/** Default fill/stroke for a filled favorite star (Figma asset). */
export const STAR_ICON_FILLED_COLOR = '#FDC700';

const iconPropTypes = {
  /** When true, star is filled; when false, outline only. */
  filled: PropTypes.bool,
  /** Icon size in px (width and height). */
  size: PropTypes.number,
  /** Path fill — defaults to `currentColor` when filled, `none` when outline. */
  fill: PropTypes.string,
  /** Path stroke — defaults to `currentColor`. */
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Star (15×15). Color via `fill` / `stroke` props or CSS `color` + `currentColor`.
 * Pass `filled` for solid star; omit or `filled={false}` for outline.
 */
const StarIcon = ({
  filled = false,
  size = 15,
  fill,
  stroke,
  strokeWidth = 1.33333,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  const pathFill = fill ?? (filled ? 'currentColor' : 'none');
  const pathStroke = stroke ?? 'currentColor';

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${STAR_VIEWBOX} ${STAR_VIEWBOX}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={['ds-icon', className].filter(Boolean).join(' ')}
      aria-hidden={ariaLabel ? undefined : ariaHidden}
      aria-label={ariaLabel || undefined}
      role={ariaLabel ? 'img' : undefined}
      focusable="false"
      {...props}
    >
      <path
        d={STAR_PATH}
        fill={pathFill}
        stroke={pathStroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

StarIcon.propTypes = iconPropTypes;

export { StarIcon };
export default StarIcon;
